import { GroupTypes } from './constants';

/**
 * Checks if a group is of groupType "organization"
 * @param group
 */
export const isOrganizationGroup = (group?: Group): boolean => {
  if (group !== undefined) {
    return group.groupType === GroupTypes.ORGANISATION;
  }
  return false;
};

/**
 * Checks if a group is of the "other people" group
 * @param group
 */
export const isPeopleGroup = (group?: Group): boolean => {
  if (group !== undefined) {
    return group.id === GroupTypes.OTHER_PEOPLE;
  }
  return false;
};
